module.exports = __webpack_public_path__ + "img/forest-unsplash.a9e872d4.jpg";